import z from 'zod';

export const storesDeliveryCompanySchema = z.array(
  z.object({
    stores_delivery_company_id: z.number(),
    stores_delivery_company_id_en: z.number().nullable().default(null),
    stores_delivery_company_id_jp: z.number().nullable().default(null),
  }),
);
